export const SET_UNITS = 'SET_UNITS'
export const TOGGLE_PROJECT_DIALOG = 'TOGGLE_PROJECT_DIALOG'
export const SAVE_PROJECT_DATA = 'SAVE_PROJECT_DATA'
export const LOAD_PROJECTS = 'LOAD_PROJECTS'
export const SELECT_PROJECT = 'SELECT_PROJECT'
export const DELETE_PROJECT = 'DELETE_PROJECT'
export const TOGGLE_SCENARIO_DIALOG = 'TOGGLE_SCENARIO_DIALOG'
export const SAVE_SCENARIO_DATA = 'SAVE_SCENARIO_DATA'
export const LOAD_SCENARIOS = 'LOAD_SCENARIOS'
export const SELECT_SCENARIO = 'SELECT_SCENARIO'
export const DELETE_SCENARIO = 'DELETE_SCENARIO'
export const SAVE_OBSTACLE_DATA = 'SAVE_OBSTACLE_DATA'
export const UPDATE_OBSTACLE_DATA = 'UPDATE_OBSTACLE_DATA'
export const UPDATE_OBSTACLE_BY_GUID = 'UPDATE_OBSTACLE_BY_GUID'
export const SELECT_OBSTACLE = 'SELECT_OBSTACLE'
export const DELETE_OBSTACLE = 'DELETE_OBSTACLE'
export const DELETE_OBSTACLE_BY_GUID = 'DELETE_OBSTACLE_BY_GUID'
export const SAVE_ATTACK_DATA = 'SAVE_ATTACK_DATA'
export const UPDATE_ATTACK_DATA = 'UPDATE_ATTACK_DATA'
export const UPDATE_ATTACK_BY_GUID = 'UPDATE_ATTACK_BY_GUID'
export const SELECT_ATTACK = 'SELECT_ATTACK'
export const DELETE_ATTACK = 'DELETE_ATTACK'
export const DELETE_ATTACK_BY_GUID = 'DELETE_ATTACK_BY_GUID'
export const RESET = 'RESET'
export const SET_MAP_CHOICE = 'SET_MAP_CHOICE'
export const UPDATE_PROJECT_BUILDINGS = 'UPDATE_PROJECT_BUILDINGS'
export const ACCEPT_T_AND_C = 'ACCEPT_T_AND_C'
export const RESET_T_AND_C = 'RESET_T_AND_C'
